<template>
	<div class="header">
		<md-progress class="progress md-accent" md-indeterminate v-if="showLoading"></md-progress>

		<md-whiteframe class="content row center-xs middle-xs">
			<section class="lang col-md-4">
				<md-menu>
					<md-button md-menu-trigger>
						<span v-if="currentLang == 'hu'">
							<img src="../assets/flag_hu.png" class="flag">
							<span>HUN</span>
						</span>
						<span v-else>
							<img src="../assets/flag_gb.png" class="flag">
							<span>ENG</span>							
						</span>						
					</md-button>
					<md-menu-content>
						<md-menu-item v-on:click="changeLang('en')">
							<img src="../assets/flag_gb.png" class="flag">
							<span>ENG</span>
						</md-menu-item>
						<md-menu-item v-on:click="changeLang('hu')">
							<img src="../assets/flag_hu.png" class="flag">
							<span>HUN</span>
						</md-menu-item>
					</md-menu-content>
				</md-menu>
			</section>
			<router-link to="/" class="logo col-md-4">
				<img src="../assets/pulmoment_wide.png" class="logo">
			</router-link>
			<section class="menu col-md-4">
			</section>
		</md-whiteframe>

		<md-sidenav class="md-right" ref="rightSidenav" @open="open('Right')" @close="close('Right')">
			<md-toolbar>
				<div class="md-toolbar-container">
					<h3 class="md-title">{{$t("sign_in")}}</h3>
				</div>
			</md-toolbar>

			<div class="auth">
				<form novalidate @submit.stop.prevent="submit">
					<md-input-container>
						<label>{{$t("email")}}</label>
						<md-input v-model="email"></md-input>
					</md-input-container>

					<md-input-container>
						<label>{{$t("password")}}</label>
						<md-input v-model="password" type="password"></md-input>
					</md-input-container>
				</form>
				<md-checkbox v-model="rememberMail">E-mail cím megjegyzése</md-checkbox><br>
				<md-button class="md-raised" v-on:click="login">{{$t("sign_in")}}</md-button>
				<md-button class="md-raised md-warn" @click="closeRightSidenav">{{$t("cancel")}}</md-button>

				<p>{{$t("signin_note")}}</p>
				<router-link tag="md-button" to="/registration" class="md-primary">{{$t("registration")}}</router-link>

				<p>Elfelejtett jelszó esetén adja meg a fenti mezőben az e-mail címét és kattintson az alábbi gombra:</p>
				<md-button class="md-primary" v-on:click="passwordReset">Jelszó visszaállítás</md-button>
			</div>
		</md-sidenav>

	</div>
</template>

<script>
	import Api from '../../generated'
	import Vue from 'vue'
	import moment from 'moment'

	export default {
		data(){
			return {
				email: undefined,
				password: undefined,
				authorized: false,
				showLoading: false,
				rememberMail: true,
				currentLang: this.$i18n.locale
			}
		},
		methods: {
			changeLang(lang){
				this.$i18n.locale = lang;
				this.currentLang = lang;
				Api.ApiClient.instance.apiClient.defaultHeaders["languageId"] = lang;
				this.$cookie.set('lang', lang);
				// TODO: fix moment locale
				// moment.locale(lang);
			},
			toggleRightSidenav() {
				this.$refs.rightSidenav.toggle();
			},
			closeRightSidenav() {
				this.$refs.rightSidenav.close();
			},
			login(){
				//TODO: IMPORTANT! Manually added request.withCredentials(); to generated api to enable cors auth! Make this automated!
				Api.ApiClient.instance.login({
					'email': this.email,
					'password': this.password
				}, (error, data, response) => {
					if (error) {
						console.error(error);
						this.$bus.$emit('showToast','Sikertelen bejelentkezés');
					} else {
						console.log('API called successfully. Returned data: ');
						console.log(JSON.stringify(response));
						if(this.rememberMail){
							this.$localStorage.set('email', this.email);
						}
						this.checkUser();
						this.$router.push('/admin/');
					}
				})
			},
			passwordReset(){
				Api.ApiClient.instance.forgottenPassword({'email': this.email}, (error, data, response) => {
					if (error) {
						console.error(error);
						this.$bus.$emit('showToast','Hiba történt, próbálja meg később');
					} else {
						this.$bus.$emit('showToast','Jelszó visszaállító email elküldve');
					}
				})
			},
			checkUser(){
				Api.ApiClient.instance.profile((error, data, response) => {
					if (error) {
						this.authorized = false
					} else {
						console.log('logged in?')
						this.authorized = true
					}
				})
			},
			logout(){
				Api.ApiClient.instance.logout((error, data, response) => {
					if (error) {
						console.error(error);
					} else {
						console.log(data);
						this.checkUser();
						this.$router.push('/');
					}
				});
			}
		},
		watch:{
			rememberMail(val){
				if(!val){
					this.$localStorage.remove('email');
				}
			}
		},
		created(){
			this.$bus.$on('showLoading', (val) => {
				this.showLoading = val;
			});
			this.$bus.$on('showLogin', () => {
				if(this.authorized){
					this.$router.push('/admin/');
				}else{
					this.$refs.rightSidenav.toggle();
				}
			});
		},
		mounted(){
			this.checkUser();
			console.log(this.$localStorage.get('email'));
			this.email = this.$localStorage.get('email');
		}
	}
</script>

<style scoped>
	.progress{
		position: absolute;
		z-index: 10;
		top: 0;
	}
	.content{
		padding: 8px;
		text-align: center;
	}
	.logo{
		height: 32px;
	}
	.auth{
		padding: 8px;
	}
	.md-button{
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// Navbar.vue?de3972ae